const baseURL = 'https://twentysevenimportados.mirabyte.com.ar/';

export default baseURL;
